import script from "./DatabaseComponent.vue?vue&type=script&lang=ts&async=true&setup=true"
export * from "./DatabaseComponent.vue?vue&type=script&lang=ts&async=true&setup=true"

import "./DatabaseComponent.vue?vue&type=style&index=0&id=7fcca107&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7fcca107"]])

export default __exports__